import React from "react";
import { Row, Col } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import "./input.scss";

function TextAreaField(props) {
  const {
    id,
    label,
    value,
    onChange,
    forwardRef,
    placeholder,
    validationMsg,
    layoutStyle,
    required,
    labelColSize,
    inputColSize,
    rows,
    name,
    attachIcon
  } = props;

  const renderLayout = () => {
    switch (layoutStyle) {
    case "horizontal":
      return (
        <Row>
          <Col md={labelColSize || 5}>
            <Form.Label htmlFor={id}>
              {label} {required && <span className="text-danger">*</span>}
            </Form.Label>
          </Col>
          <Col md={inputColSize || 7}>
            <Form.Control
              as="textarea"
              id={id}
              placeholder={placeholder}
              className={"input-field"}
              name={name}
              value={value}
              onChange={onChange}
              ref={forwardRef}
              rows={rows || 3}
            />
            {attachIcon && attachIcon}
            {validationMsg && <div className="text-danger validation-msg">{validationMsg}</div>}
          </Col>
        </Row>
      );
    case "chat-input":
      return (
        <Row>
          <Col>
            <Form.Control
              as="textarea"
              id={id}
              placeholder={placeholder}
              className={"input-field"}
              name={name}
              value={value}
              onChange={onChange}
              ref={forwardRef}
              rows={rows || 3}
            />
            {attachIcon && attachIcon}
            {validationMsg && <div className="text-danger validation-msg">{validationMsg}</div>}
          </Col>
        </Row>
      );
    case "vertical":
    default:
      return (
        <div className="text-area-container">
          <Form.Label htmlFor={id}>
            {label} {required && <span className="text-danger">*</span>}
          </Form.Label>
          <div className="textarea-wrapper">
            <Form.Control
              as="textarea"
              id={id}
              placeholder={placeholder}
              className={"input-field"}
              name={name}
              value={value}
              onChange={onChange}
              ref={forwardRef}
              rows={rows || 3}
            />
            {attachIcon && attachIcon}
          </div>
          {validationMsg && <div className="text-danger validation-msg">{validationMsg}</div>}
        </div>
      );
    }
  };

  return renderLayout();
}

export default TextAreaField;
